import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, CUIText } from '@dotcom/crown-ui';
import CrownRewards from '../../../assets/crown-rewards.svg';

export const useLoyaltyContents = () => {
  const { t } = useTranslation();

  const containerText = (
    <CUIText as="span" color="textPrimary">
      {t('noCrNoHDialog.firstContainerText')}
    </CUIText>
  );

  const joinCrownRewardsButton = (
    <Button variant="primary" onClick={() => window.location.replace('/crown-rewards/')} testId="loyalty-dialog-button">
      {t('noCrNoHDialog.firstContainerButtonText')}
    </Button>
  );

  const loyaltyContainerContents = {
    image: CrownRewards,
    body: containerText,
    btnAction: joinCrownRewardsButton,
  };

  return { loyaltyContainerContents };
};
